import { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

class BaseSearch extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ordination: {
        RELEVANCE: false,
        NEWRELEASES: false,
        PRICELOWERTOHIGHER: false,
        PRICEHIGHERTOLOWER: false,
        SCORE: true,
        checked: false
      },
      condition: false
    }
  }

  pageIndexInfinity = 0
  metaApplied = false

  handleFilter = () => {
    this.setState({ condition: !this.state.condition })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.filtersName !== this.props.filtersName) {
      this.setFilterByQueryString()
    }

    if (this.props.showcase && this.props.showcase.description && !this.metaApplied) {
      this.props.setMeta(this.props.showcase.description)
      this.metaApplied = true
    }
  }

  componentDidMount () {
    this.setFilterByQueryString()
  }

  loadItems = () => {
    if (!this.props.isLoading) {
      let {
        term,
        identifier,
        type,
        brand,
        category,
        subcategory,
        vendor,
        vendortype,
        feature,
        minprice,
        maxprice,
        sort
      } = this.props.filterSelected

      this.props.fetchResultSearch(
        term,
        identifier,
        type,
        brand,
        category,
        subcategory,
        vendor,
        vendortype,
        feature,
        minprice,
        maxprice,
        sort,
        this.pageIndexInfinity++
      )
    }
  }

  handleOrdination (type) {
    switch (type) {
      case 'RELEVANCE':
        this.setState({
          ordination: {
            RELEVANCE: true,
            NEWRELEASES: false,
            PRICELOWERTOHIGHER: false,
            PRICEHIGHERTOLOWER: false,
            SCORE: false,
            checked: true
          }
        })
        break
      case 'NEWRELEASES':
        this.setState({
          ordination: {
            RELEVANCE: false,
            NEWRELEASES: true,
            PRICELOWERTOHIGHER: false,
            PRICEHIGHERTOLOWER: false,
            SCORE: false,
            checked: true
          }
        })
        break

      case 'PRICELOWERTOHIGHER':
        this.setState({
          ordination: {
            RELEVANCE: false,
            NEWRELEASES: false,
            PRICELOWERTOHIGHER: true,
            PRICEHIGHERTOLOWER: false,
            SCORE: false,
            checked: true
          }
        })
        break

      case 'PRICEHIGHERTOLOWER':
        this.setState({
          ordination: {
            RELEVANCE: false,
            NEWRELEASES: false,
            PRICELOWERTOHIGHER: false,
            PRICEHIGHERTOLOWER: true,
            SCORE: false,
            checked: true
          }
        })
        break

      case 'SCORE':
        this.setState({
          ordination: {
            RELEVANCE: false,
            NEWRELEASES: false,
            PRICELOWERTOHIGHER: false,
            PRICEHIGHERTOLOWER: false,
            SCORE: true,
            checked: true
          }
        })
        break

      default:
        this.setState({
          ordination: {
            RELEVANCE: false,
            NEWRELEASES: false,
            PRICELOWERTOHIGHER: false,
            PRICEHIGHERTOLOWER: false,
            SCORE: false,
            checked: false
          }
        })
        break
    }
  }

  handleSelectOrdinationFilterChanged = (selectedOrdenation) => {
    const mustFetch = true
    const filterType = 'sort'
    let {
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort
    } = this.props.filterSelected

    sort = this.setFilterValue(sort, selectedOrdenation, filterType)
    this.handleOrdination(sort)

    let mustChangeUrl = true
    this.setFilter(
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort,
      mustChangeUrl,
      mustFetch,
      filterType
    )
  }

  handleFilterRemove = (filterType, filterValue) => {
    let filterAction = 'remove'

    if (filterType === 'minprice' || filterType === 'maxprice') {
      filterAction = 'update'
    }

    const mustFetch = true

    let {
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort
    } = this.props.filterSelected

    switch (filterType) {
      case 'category': {
        category = this.setFilterValue(category, filterValue, filterAction)
        break
      }
      case 'subcategory': {
        subcategory = this.setFilterValue(
          subcategory,
          filterValue,
          filterAction
        )
        break
      }
      case 'brand': {
        brand = this.setFilterValue(brand, filterValue, filterAction)
        break
      }
      case 'vendor': {
        vendor = this.setFilterValue(vendor, filterValue, filterAction)
        break
      }
      case 'vendorType': {
        vendortype = this.setFilterValue(vendortype, filterValue, filterAction)
        break
      }
      case 'feature': {
        feature = this.setFilterValue(feature, filterValue, filterAction)
        break
      }
      case 'minprice': {
        minprice = this.setFilterValue(minprice, filterValue, filterAction)
        break
      }
      case 'maxprice': {
        maxprice = this.setFilterValue(maxprice, filterValue, filterAction)
        break
      }
      case 'price': {
        minprice = this.setFilterValue(minprice, filterValue.target.getAttribute('minprice'), filterAction)
        maxprice = this.setFilterValue(maxprice, filterValue.target.getAttribute('maxprice'), filterAction)
        break
      }
      case 'sort': {
        sort = this.setFilterValue(sort, filterValue, filterAction)
        this.handleOrdination(sort)
        break
      }
      case 'term': {
        term = this.setFilterValue(term, filterValue, filterAction)
        break
      }
      case 'identifier': {
        identifier = this.setFilterValue(identifier, filterValue, filterAction)
        break
      }
      case 'type': {
        type = this.setFilterValue(type, filterValue, filterAction)
        break
      }
    }

    let mustChangeUrl = true
    this.setFilter(
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort,
      mustChangeUrl,
      mustFetch,
      filterType
    )
  }

  handleFilterChanged = (filterType, mustFetch = true) => e => {
    let filterValue
    let filterAction = 'update'
    let tagType = e.target ? String(e.target.type) : ''

    switch (tagType) {
      case 'checkbox': {
        filterValue = e.target.value
        filterAction = e.target.checked ? 'add' : 'remove'
        break
      }
      case 'text': {
        filterValue = e.target.value
        break
      }
      default: {
        if (e.target) {
          filterAction = e.target.getAttribute('action')
          filterValue = e.target.getAttribute('value')
        }
        break
      }
    }

    filterAction = filterAction || 'update'
    filterValue = filterValue || e

    let {
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort
    } = this.props.filterSelected

    switch (filterType) {
      case 'category': {
        category = this.setFilterValue(category, filterValue, filterAction)
        break
      }
      case 'subcategory': {
        subcategory = this.setFilterValue(
          subcategory,
          filterValue,
          filterAction
        )
        break
      }
      case 'brand': {
        brand = this.setFilterValue(brand, filterValue, filterAction)
        break
      }
      case 'vendor': {
        vendor = this.setFilterValue(vendor, filterValue, filterAction)
        break
      }
      case 'vendorType': {
        vendortype = this.setFilterValue(vendortype, filterValue, filterAction)
        break
      }
      case 'feature': {
        feature = this.setFilterValue(feature, filterValue, filterAction)
        break
      }
      case 'minprice': {
        minprice = this.setFilterValue(minprice, filterValue, filterAction)
        break
      }
      case 'maxprice': {
        maxprice = this.setFilterValue(maxprice, filterValue, filterAction)
        break
      }
      case 'price': {
        minprice = this.setFilterValue(minprice, filterValue.target.getAttribute('minprice'), filterAction)
        maxprice = this.setFilterValue(maxprice, filterValue.target.getAttribute('maxprice'), filterAction)
        break
      }
      case 'sort': {
        sort = this.setFilterValue(sort, filterValue, filterAction)
        this.handleOrdination(sort)
        break
      }
      case 'term': {
        term = this.setFilterValue(term, filterValue, filterAction)
        break
      }
      case 'identifier': {
        identifier = this.setFilterValue(identifier, filterValue, filterAction)
        break
      }
      case 'type': {
        type = this.setFilterValue(type, filterValue, filterAction)
        break
      }
    }

    let mustChangeUrl = true
    this.setFilter(
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort,
      mustChangeUrl,
      mustFetch,
      filterType
    )
  }

  handleFilterClean = pageType => e => {
    let mustChangeUrl = true
    let mustFetch = true
    let filterType = 'subcategory'

    let {
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort
    } = this.props.filterSelected

    if (pageType !== 'vendor') {
      vendor = []
    }

    brand = []
    category = []
    subcategory = []
    vendortype = []
    feature = []
    minprice = 0
    maxprice = 0
    sort = undefined

    this.setFilter(
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortype,
      feature,
      minprice,
      maxprice,
      sort,
      mustChangeUrl,
      mustFetch,
      filterType
    )

    this.setState({
      ordination: {
        RELEVANCE: false,
        NEWRELEASES: false,
        PRICELOWERTOHIGHER: false,
        PRICEHIGHERTOLOWER: false,
        SCORE: false,
        checked: false
      }
    })
  }

  setFilter = (
    term,
    identifier,
    type,
    brand,
    category,
    subcategory,
    vendor,
    vendortype,
    feature,
    minprice,
    maxprice,
    sort,
    mustChangeUrl,
    mustFetch,
    filterType
  ) => {
    let filterSelected = {
      term: term,
      identifier,
      type,
      brand: brand,
      category: category,
      subcategory: subcategory,
      vendor: vendor,
      vendortype: vendortype,
      feature: feature,
      minprice: minprice,
      maxprice: maxprice,
      sort: sort
    }

    this.props.setFilterChanged(filterType, filterSelected)

    if (mustChangeUrl) {
      this.setQueryString(filterSelected)
    }

    if (mustFetch) {
      this.props.clearSearch()
      this.pageIndexInfinity = 0

      this.props.fetchResultSearch(
        term,
        identifier,
        type,
        brand,
        category,
        subcategory,
        vendor,
        vendortype,
        feature,
        minprice,
        maxprice,
        sort,
        this.pageIndexInfinity++
      )
    }
  }

  setQueryString = filterSelected => {
    let filterQueryString = ''
    Object.keys(filterSelected).map(key => {
      let filterQS = filterSelected[key]
      if (filterQS !== undefined && filterQS.toString() !== '') {
        filterQueryString +=
          (filterQueryString ? '&' : '') + key + '=' + filterQS.toString()
      }
    })

    let urlChanged =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?' +
      filterQueryString
    window.history.pushState({ path: urlChanged }, '', urlChanged)
  }

  setFilterByQueryString = () => {
    let {
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortypes,
      feature,
      minprice,
      maxprice,
      sort
    } = queryString.parse(this.props.filtersName)

    brand = this.setFilterValue(null, brand, 'add')
    category = this.setFilterValue(null, category, 'add')
    subcategory = this.setFilterValue(null, subcategory, 'add')
    vendor = this.setFilterValue(null, vendor, 'add')
    vendortypes = this.setFilterValue(null, vendortypes, 'add')
    feature = this.setFilterValue(null, feature, 'add')

    minprice = this.setFilterValue(
      null,
      minprice || this.props.filterSelected.minprice,
      'update'
    )
    maxprice = this.setFilterValue(
      null,
      maxprice || this.props.filterSelected.maxprice,
      'update'
    )

    let mustFetch = true
    let mustChangeUrl = false
    let filterType = 'querystring'
    this.setFilter(
      term,
      identifier,
      type,
      brand,
      category,
      subcategory,
      vendor,
      vendortypes,
      feature,
      minprice,
      maxprice,
      sort,
      mustChangeUrl,
      mustFetch,
      filterType
    )
  }

  setFilterValue = (sideBarFilter, valueFilter, action) => {
    sideBarFilter = sideBarFilter || []

    if (valueFilter === undefined) {
      return sideBarFilter
    }

    if (!Array.isArray(valueFilter)) {
      valueFilter = isNaN(valueFilter) ? valueFilter.split(',') : [valueFilter]
    }

    valueFilter.map(valueItem => {
      if (valueItem !== undefined && valueItem !== null) {
        switch (action) {
          case 'add': {
            sideBarFilter.push(String(valueItem))
            break
          }
          case 'remove': {
            sideBarFilter = sideBarFilter.filter(value => {
              return value !== String(valueItem)
            })
            break
          }
          default: {
            sideBarFilter = isNaN(valueItem)
              ? valueItem.length > 0
                ? String(valueItem)
                : null
              : valueItem
          }
        }
      }
    })
    return sideBarFilter
  }
}

BaseSearch.propTypes = {
  fetchResultSearch: PropTypes.func.isRequired,
  filterSelected: PropTypes.object,
  clearSearch: PropTypes.func.isRequired,
  setFilterChanged: PropTypes.func.isRequired,
  filtersName: PropTypes.any,
  isLoading: PropTypes.bool,
  setMeta: PropTypes.func.isRequired,
  showcase: PropTypes.any
}

export default BaseSearch



// WEBPACK FOOTER //
// ./src/Catalog/Search/Search/BaseSearch.js